<div class="timer">
  <span id="hours" *ngIf="hoursToDday">{{hoursToDday}}:</span>
  <span id="minutes"><span *ngIf="minutesToDday < 10">0</span>{{minutesToDday}}:</span>
  <span id="seconds"><span *ngIf="secondsToDday < 10">0</span>{{secondsToDday}}</span>
</div>
